import { IdTokenResult, User } from "firebase/auth";

export const meticulousTestUser = {
  uid: "meticulous-user-id",
  email: "meticulous@chaptr.xyz",
  emailVerified: true,
  isAnonymous: false,
  displayName: "Meticulous",
  phoneNumber: null,
  photoURL: null,
  providerId: "firebase",
  metadata: {
    creationTime: "0",
    lastSignInTime: "0",
    lastLoginAt: "0",
    createdAt: "0",
  },
  providerData: [],
  refreshToken: "refreshToken",
  tenantId: null,
  delete: () => Promise.resolve(),
  getIdToken: () => Promise.resolve("token"),
  getIdTokenResult: () => Promise.resolve({} as IdTokenResult),
  reload: () => Promise.resolve(),
  toJSON: () => ({}),
} as unknown as User;
